import Utility from "@/helper/Utility";

export function QueryStringDataModel() {
    this.appId = null;
    this.appName = null;
    this.apiPrefix = null;
    this.campaignId = null;
    this.walletCardId = null;
    this.contact_number = null;
    this.historyUrl = null;
    this.locale = null;
    this.otp = null;
    this.refcode = null;
    this.returnUrl = null;
    this.theme = null;
    this.token = null;
    this.wallet_token = null;
    this.withholdingtax_key = null;
    this.shoppingCartUrl = null;
    this.shoppingCartApi = null;
    this.loginName = null;
    this.partial_points = null;
    this.partial_baht = null;
    this.is_test = null;
    this.info1 = null;
    this.info2 = null;
    this.info3 = null;
    this.info4 = null;
    this.info5 = null;
    this.header = null
    this.rawToken = null
}

QueryStringDataModel.prototype.saveCache = function () {
    let json = JSON.stringify(this)
    sessionStorage.setItem("t1c.query", json)

    return this
}

QueryStringDataModel.prototype.loadCache = function () {
    let raw = sessionStorage.getItem("t1c.query")
    let json = JSON.parse(raw)

    this.appId = json?.appId ?? null;
    this.appName = json?.appName ?? null;
    this.apiPrefix = json?.apiPrefix ?? null;
    this.campaignId = json?.campaignId ?? null;
    this.walletCardId = json?.walletCardId ?? null;
    this.contact_number = json?.contact_number ?? null;
    this.historyUrl = json?.historyUrl ?? null;
    this.locale = json?.locale ?? null;
    this.otp = json?.otp ?? null;
    this.refcode = json?.refcode ?? null;
    this.returnUrl = json?.returnUrl ?? null;
    this.theme = json?.theme ?? null;
    this.token = json?.token ?? null;
    this.wallet_token = json?.wallet_token ?? null;
    this.withholdingtax_key = json?.withholdingtax_key ?? null;
    this.shoppingCartUrl = json?.shoppingCartUrl ?? null;
    this.shoppingCartApi = json?.shoppingCartApi ?? null;
    this.loginName = json?.loginName ?? null;
    this.partial_points = json?.partial_points ?? null;
    this.partial_baht = json?.partial_baht ?? null;
    this.is_test = json?.is_test ?? null;
    this.info1 = json?.info1 ?? null;
    this.info2 = json?.info2 ?? null;
    this.info3 = json?.info3 ?? null;
    this.info4 = json?.info4 ?? null;
    this.info5 = json?.info5 ?? null;
    this.header = json?.header ?? null;
    this.rawToken = json?.rawToken ?? null;

    return this
}

QueryStringDataModel.prototype.toQuery = function () {
    let json = {
        app_id: this.appId,
        campaign_id: this.campaignId,
        theme: this.theme,
        return_url: this.returnUrl,
        locale: this.locale,
        token: this.rawToken,
        withholdingtax_key: this.withholdingtax_key,
        info1: this.info1,
        info2: this.info2,
        info3: this.info3,
        info4: this.info4,
        info5: this.info5,
        header: this.header,
        history_url: this.historyUrl
    }

    return Utility.cleanObjectEmptyStr(json)
}
